"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppHeaderConfig = void 0;
const getAppHeaderConfig = ({ pageConfig, }) => {
    const { config, menuName, newCoverPictureNarrow: coverPictureNarrow, newCoverPictureNormal: coverPictureNormal, newCoverPictureWide: coverPictureWide, shortDescription, title, } = pageConfig;
    return {
        disableCoverPicture: !(config === null || config === void 0 ? void 0 : config.enableCoverPicture),
        disableDescription: !(config === null || config === void 0 ? void 0 : config.enableDescription),
        title: title || menuName,
        description: shortDescription,
        coverPicture: coverPictureNormal,
        coverPictureWide,
        coverPictureNarrow,
    };
};
exports.getAppHeaderConfig = getAppHeaderConfig;
//# sourceMappingURL=index.js.map